import { Helmet } from 'react-helmet-async';

const ProjectorPage = () => {

    return (
        <div>
            <Helmet>
                <title>Room 49 - Projector</title>
                <meta name="description" content="Guidelines on how to use the Room 49 basement projector." />
                <link rel="canonical" href='https://thetypingrooms.co.uk/projector' />
            </Helmet>
            <div className="page">
                <div className='page-header'>
                    <h1>Basement Projector</h1>
                </div>
                <div className='page-content'>
                    <h2>Availability</h2>
                    <p>
                        The projector is there if you'd like to use it—it's made available "as-is" on a self-service basis only, with no support or guarantees. Unfortunately, we're not available to help troubleshoot, so if it doesn't work for any reason, you may need to work without it.
                    </p>
                    <h2>Setup</h2>
                    <p>
                        Turn the projector on with the power button in the top corner of the remote. The projector is already fixed to the ceiling in the best position—please don't try to move or adjust it directly. Before you get started, pull down the projector screen in front of the whiteboard. You'll need to pull it slightly towards you for it to catch and stay down.
                    </p>
                    <h2>Connection</h2>
                    <p>
                        The best way to use the projector is screen mirroring, so make sure your laptop is connected to the office Wi-Fi "room 49" (this isn't a Bluetooth connection). Also please note that phone mirroring is not supported. Once the projector is on, use the arrows on the remote to select Miracast, then press OK. Now on your device, go to Display Settings &rarr; Connect to a wireless display &rarr; select P62-AnCast-acdf. You should now see your laptop screen mirrored on the projector.
                    </p>
                    <h2>
                        Usage
                    </h2>
                    <p>
                        The screen should auto-focus. Keystone adjustment can sometimes be fiddly, so use the remote to correct the shape of the image if it looks stretched or skewed. Sound will come through the projector.
                        If you want to turn out the lights in the room so the screen is clearer, there is a large white switch just behind the projector on the ceiling. This controls the lights for this room only.
                    </p>
                    <h2>Firestick</h2>
                    <p>
                        There's a Fire Stick already plugged into the projector. Basic apps like Netflix, Prime Video, Disney+, iPlayer and ITVX are pre-installed. Just switch to the correct HDMI 1 input on the projector homescreen. The Fire Stick homescreen will then open and and you can choose the app you want. You'll need to log into your own account to use the apps, so please don't forget to log out afterwards if you're using a shared service.
                    </p>
                    <h2>Finally</h2>
                    <p>
                        When you're done, just switch off using the remote—and roll the screen back up.
                    </p>
                </div>
            </div>
        </div>
    );
};

export default ProjectorPage;
